import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TransactionSource } from '../../shared/models/invoice/payment.model';
import { ACHOnFilePayment, ACHPayment } from '../../shared/models/invoice/ach-payment.model';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

const httpOptionsDownload = {
  headers: {
    'Content-Type': 'application/json',
  },
  params: null,
  reportProgress: true,
  responseType: 'arraybuffer',
  withCredentials: false,
};

@Injectable({
  providedIn: 'root',
})
export class ACHPaymentService {
  private baseRoute: string;

  constructor(private httpClient: HttpClient) {
    this.baseRoute = environment.paymentAPIRoot;
  }

  achCharge<T>(payload: ACHPayment): Observable<T> {
    return this.httpClient.post<T>(
      `${this.baseRoute}/api/ach/charge`,
      payload,
      httpOptions
    );
  }
  
  achOnFileCharge<T>(payload: ACHOnFilePayment): Observable<T> {
    return this.httpClient.post<T>(
      `${this.baseRoute}/api/ach/achonfilecharge`,
      payload,
      httpOptions
    );
  }

  achVoid<T>(payload: ACHPayment): Observable<T> {
    payload.TransactionSource = TransactionSource.Merchant;
    return this.httpClient.post<T>(
      `${this.baseRoute}/api/ach/void`,
      payload,
      httpOptions
    );
  }

  achReverse<T>(payload: ACHPayment): Observable<T> {
    return this.httpClient.post<T>(
      `${this.baseRoute}/api/ach/reverse`,
      payload,
      httpOptions
    );
  }

  achRefund<T>(payload: ACHPayment): Observable<T> {
    return this.httpClient.post<T>(
      `${this.baseRoute}/api/ach/refund`,
      payload,
      httpOptions
    );
  }
}
